/**
 * StatusBadge Component
 *
 * Displays status with appropriate colors for feedback items.
 */

type FeedbackStatus = 'new' | 'reviewing' | 'resolved' | 'wont_fix';

interface StatusBadgeProps {
  status: FeedbackStatus;
  className?: string;
}

const statusConfig: Record<FeedbackStatus, { label: string; className: string }> = {
  new: {
    label: 'New',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  reviewing: {
    label: 'Reviewing',
    className: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-green-100 text-green-700 border-green-200',
  },
  wont_fix: {
    label: "Won't Fix",
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  },
};

export function StatusBadge({ status, className = '' }: StatusBadgeProps): JSX.Element {
  const config = statusConfig[status] || statusConfig.new;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}

export default StatusBadge;
